{
  "home-page": {
    "meta": {
      "title": "Beauty Booking",
      "description": "đặt lịch trực tuyến, giảm giá móng tay, ưu đãi làm móng, khuyến mãi làm móng, giảm giá lông mày, ưu đãi lông mày, khuyến mãi lông mày, giảm giá lông mi, ưu đãi lông mi, khuyến mãi lông mi, giảm giá PMU, ưu đãi PMU, khuyến mãi PMU"
    },
    "text": {
      "book-appointment-again": "Đặt lịch hẹn mới tại các tiệm bạn đã ghé thăm"
    }
  }
}
